module.exports = __webpack_public_path__ + "media/assets/landing_page_make_things_with_code-ea3ed5f1.svg";